import { SURF_VISION_MODEL_ID } from "../graphql/surfApi.js";
import { compressDataUrlForVision } from "./visionImagePrep.js";
function mimeFromDataUrl(dataUrl) {
    const m = /^data:(image\/[a-z+]+);base64,(.+)$/i.exec(dataUrl.trim());
    if (!m)
        throw new Error("Immagine non valida (atteso data URL).");
    const mime = m[1].toLowerCase();
    const bytes = m[2];
    const format = mime.includes("png") ? "png" : mime.includes("gif") ? "gif" : mime.includes("webp") ? "webp" : "jpeg";
    return { format, bytes };
}
const VISION_MODEL_ID = SURF_VISION_MODEL_ID;
export async function bedrockConverseWithImage(cfg, opts) {
    const token = await cfg.getIdToken();
    const base = cfg.bedrockProxyUrl?.replace(/\/+$/, "") ?? "";
    const url = base ? `${base}/bedrock/converse` : "/bedrock/converse";
    const prepared = await compressDataUrlForVision(opts.imageDataUrl);
    const { format, bytes } = mimeFromDataUrl(prepared);
    let res;
    try {
        res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                "x-oidc-token": token,
                "X-Vida-AppId": "surf",
                "X-Vida-Feature": opts.feature,
            },
            body: JSON.stringify({
                model: opts.modelId ?? VISION_MODEL_ID,
                system: [{ text: opts.systemText }],
                messages: [
                    {
                        role: "user",
                        content: [{ text: opts.userText }, { image: { format, source: { bytes } } }],
                    },
                ],
                inferenceConfig: { maxTokens: 4096 },
            }),
        });
    }
    catch (e) {
        if (e instanceof TypeError) {
            const configured = Boolean(base);
            throw new Error(configured
                ? "Bedrock vision: impossibile contattare il proxy (rete, CORS o payload troppo grande). Verifica connessione e riprova."
                : "Bedrock proxy non configurato. In locale: VITE_BEDROCK_PROXY_URL e riavvia il dev server.");
        }
        throw e;
    }
    const text = await res.text();
    if (!res.ok)
        throw new Error(`Bedrock vision (${res.status}): ${text.slice(0, 300)}`);
    const json = JSON.parse(text);
    const output = json.output;
    const message = output?.message;
    const content = message?.content;
    if (!Array.isArray(content))
        throw new Error("Risposta vision senza testo.");
    const block = content.find((c) => c && typeof c === "object" && "text" in c);
    const out = block?.text?.trim();
    if (!out)
        throw new Error("Risposta vision vuota.");
    return out;
}
